import { Injectable } from '@angular/core';
import { Territory } from '../core/classes/territory';

export interface FilterRow {
  displayName: string,
  dbColumn: string,
  legendName: string,
  apiLegend?: boolean;
  type?: 'point' | 'line' | 'polygon';
}

export interface GlobalFilters {
  territories: Territory[],
  years: number[];
}
/**
 * @deprecated This service is deprecated and will be removed in a future version.
 * For access to the selected state, use AppService.selectedState
 */
@Injectable({
  providedIn: 'root',
})
export class GlobalFilterService {
  private cejstOptions: FilterRow[] = [
    { displayName: 'Under 10 Years', dbColumn: 'pct_underten', legendName: 'cejst_percent_attr', apiLegend: true },
    { displayName: '64+ Years', dbColumn: 'pct_plussixfour', legendName: 'cejst_percent_attr', apiLegend: true },

    { displayName: 'Percentile Disadvantaged', dbColumn: 'pct_tract_disadvantage', legendName: 'cejst_percentile_attr', apiLegend: true },
    { displayName: 'Poverty', dbColumn: 'poverty_pct', legendName: 'cejst_percentile_attr', apiLegend: true },
    { displayName: 'Unemployment', dbColumn: 'unemployment_pct', legendName: 'cejst_percentile_attr', apiLegend: true },
    { displayName: 'Life Expectancy', dbColumn: 'life_expectancy_pct', legendName: 'cejst_percentile_attr', apiLegend: true },
    { displayName: 'Within Tribal Lands', dbColumn: 'pct_tract_within_tribal', legendName: 'cejst_percentile_attr', apiLegend: true },
    { displayName: 'Housing Burden', dbColumn: 'housing_burden_pct', legendName: 'cejst_percentile_attr', apiLegend: true },

    { displayName: 'Disadvantaged', dbColumn: 'disadvantage', legendName: 'cejst_county_attr' },
    { displayName: 'Climate', dbColumn: 'climate', legendName: 'cejst_county_attr' },
    { displayName: 'Energy', dbColumn: 'energy', legendName: 'cejst_county_attr' },
    { displayName: 'Health', dbColumn: 'health', legendName: 'cejst_county_attr' },
    { displayName: 'Housing', dbColumn: 'housing', legendName: 'cejst_county_attr' },
    { displayName: 'Legacy Pollution', dbColumn: 'legacy_pollution', legendName: 'cejst_county_attr' },
    { displayName: 'Transportation', dbColumn: 'transportation', legendName: 'cejst_county_attr' },
    { displayName: 'Water/Wastewater', dbColumn: 'water_wastewater', legendName: 'cejst_county_attr' },
    { displayName: 'Workforce Development', dbColumn: 'workforce_development', legendName: 'cejst_county_attr' },
    { displayName: 'Tribal', dbColumn: 'tribal', legendName: 'cejst_county_attr' },
  ];

  private eiaOptions: FilterRow[] = [
    { displayName: 'SAIDI (MED)', dbColumn: 'ieee_saidi_med', legendName: 'eia_reliability', apiLegend: true },
    { displayName: 'CAIDI (MED)', dbColumn: 'ieee_caidi_med', legendName: 'eia_reliability', apiLegend: true },
    { displayName: 'SAIDI (No MED)', dbColumn: 'ieee_saidi_wo_med', legendName: 'eia_reliability', apiLegend: true },
    { displayName: 'CAIDI (No MED)', dbColumn: 'ieee_caidi_wo_med', legendName: 'eia_reliability', apiLegend: true },

    { displayName: 'SAIFI (MED)', dbColumn: 'ieee_saifi_med', legendName: 'eia_reliability_frequency', apiLegend: true },
    { displayName: 'SAIFI (No MED)', dbColumn: 'ieee_saifi_wo_med', legendName: 'eia_reliability_frequency', apiLegend: true },

    { displayName: 'Automated Meter Readings', dbColumn: 'amr_total', legendName: 'eia_meters', apiLegend: true },
    { displayName: 'Advanced Metering Infrastructure ', dbColumn: 'ami_total', legendName: 'eia_meters', apiLegend: true },
    { displayName: 'Standard Meters', dbColumn: 'standard_total', legendName: 'eia_meters', apiLegend: true },
    { displayName: 'All Meters', dbColumn: 'meters_total', legendName: 'eia_meters', apiLegend: true },
    { displayName: 'AMI Meters', dbColumn: 'ami_energy_total', legendName: 'eia_meters', apiLegend: true },

    { displayName: 'Volt Optimized Circuits', dbColumn: 'circuits_voltage_optimization', legendName: 'eia_distribution', apiLegend: true },
    { displayName: 'Distribution Circuits', dbColumn: 'distribution_circuits', legendName: 'eia_distribution', apiLegend: true },
  ];


  private fireOptions: FilterRow[] = [
    { displayName: 'Burn Probability', dbColumn: 'bp', legendName: 'fsim_burn_probability', apiLegend: true },
    { displayName: 'Moderate Wildfire Probability', dbColumn: 'bp_flp_4', legendName: 'fsim_burn_probability', apiLegend: true },
    { displayName: 'High-Intensity Wildfire Probability', dbColumn: 'bp_flp_8', legendName: 'fsim_burn_probability', apiLegend: true },
    { displayName: 'State-level Burn Index', dbColumn: 'rpl_bp', legendName: 'state_burn_index', apiLegend: true },
    { displayName: 'State-level Moderate Fire Index', dbColumn: 'rpl_bp_flp_4', legendName: 'state_burn_index', apiLegend: true },
    { displayName: 'State-level High-Intensity Fire Index', dbColumn: 'rpl_bp_flp_8', legendName: 'state_burn_index', apiLegend: true },
  ];

  private icfOptions: FilterRow[] = [
    // Substations
    { displayName: 'Annual probability of days above 35°C', dbColumn: 'ap_count_over_35_2008_2022', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of days above 40°C', dbColumn: 'ap_count_over_40_2008_2022', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of days above 45°C', dbColumn: 'ap_count_over_45_2008_2022', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of days under 0°C', dbColumn: 'ap_count_under_0_2008_2022', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of days under -17.78°C', dbColumn: 'ap_count_under_neg17_2008_2022', legendName: 'substation_exposure', apiLegend: true, type: 'point' },

    { displayName: 'Annual probability of Category 5 storm', dbColumn: 'annprob_m', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of Category 2 inundation in percent', dbColumn: 'annualprob_all', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 1 Hurricane storm', dbColumn: 'category1', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 2 Hurricane storm', dbColumn: 'category2', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 3 Hurricane storm', dbColumn: 'category3', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 4 Hurricane storm', dbColumn: 'category4', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 5 Hurricane storm', dbColumn: 'category5', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Tropical Storm Wind - AP 111 mph Gusts:', dbColumn: 'ts_111_ap', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Tropical Storm Wind - AP 74 mph Gusts:', dbColumn: 'ts_74_ap', legendName: 'substation_exposure', apiLegend: true, type: 'point' },

    { displayName: 'Burn probability', dbColumn: 'bp', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Drought Risk Index score', dbColumn: 'drgt_afreq', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual likelihood of an asset being inundated through 2100', dbColumn: 'slr_ap_inthigh_1', legendName: 'substation_exposure', apiLegend: true, type: 'point' },

    { displayName: 'Sea level Rise Inundation depth in feet', dbColumn: 'slr_ft', legendName: 'substation_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Tornado Annualized Frequency', dbColumn: 'trnd_afreq', legendName: 'substation_exposure', apiLegend: true, type: 'point' },

    // Power plants
    { displayName: 'Annual probability of days above 35°C', dbColumn: 'ap_count_over_35_2008_2022', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of days above 40°C', dbColumn: 'ap_count_over_40_2008_2022', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of days above 45°C', dbColumn: 'ap_count_over_45_2008_2022', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of days under 0°C', dbColumn: 'ap_count_under_0_2008_2022', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of days under -17.78°C', dbColumn: 'ap_count_under_neg17_2008_2022', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },

    { displayName: 'Annual probability of Category 5 storm', dbColumn: 'annprob_m', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual probability of Category 2 inundation in percent', dbColumn: 'annualprob_all', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 1 Hurricane storm', dbColumn: 'category1', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 2 Hurricane storm', dbColumn: 'category2', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 3 Hurricane storm', dbColumn: 'category3', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 4 Hurricane storm', dbColumn: 'category4', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Depth above ground in ft for Category 5 Hurricane storm', dbColumn: 'category5', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Tropical Storm Wind - AP 74 mph Gusts:', dbColumn: 'ts_74_ap', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },

    { displayName: 'Burn probability', dbColumn: 'bp', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Drought Risk Index score', dbColumn: 'drgt_afreq', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Annual likelihood of an asset being inundated through 2100', dbColumn: 'slr_ap_inthigh', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },

    { displayName: 'Sea level Rise Inundation depth in feet', dbColumn: 'slr_ft', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },
    { displayName: 'Tornado Annualized Frequency', dbColumn: 'trnd_afreq', legendName: 'powerplant_exposure', apiLegend: true, type: 'point' },

    // Transmission Lines
    { displayName: 'Annual probability of days above 35°C', dbColumn: 'ap_count_over_35_2008_2022', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Annual probability of days above 40°C', dbColumn: 'ap_count_over_40_2008_2022', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Annual probability of days above 45°C', dbColumn: 'ap_count_over_45_2008_2022', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Annual probability of days under 0°C', dbColumn: 'ap_count_under_0_2008_2022', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Annual probability of days under -17.78°C', dbColumn: 'ap_count_under_neg17_2008_2022', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },

    { displayName: 'Annual probability of Category 5 storm', dbColumn: 'annprob_m', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Annual probability of Category 2 inundation in percent', dbColumn: 'annualprob_all', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Depth above ground in ft for Category 1 Hurricane storm', dbColumn: 'category2', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Depth above ground in ft for Category 2 Hurricane storm', dbColumn: 'category3', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Depth above ground in ft for Category 3 Hurricane storm', dbColumn: 'category4', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Depth above ground in ft for Category 4 Hurricane storm', dbColumn: 'category5', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Depth above ground in ft for Category 5 Hurricane storm', dbColumn: 'count_over_35_2008_2022', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Tropical Storm Wind - AP 74 mph Gusts:', dbColumn: 'ts_74_ap', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },

    { displayName: 'Burn probability', dbColumn: 'category1', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Drought Risk Index score', dbColumn: 'slr_ap_inthigh', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Annual likelihood of an asset being inundated through 2100', dbColumn: 'slr_ft', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },

    { displayName: 'Sea level Rise Inundation depth in feet', dbColumn: 'trnd_afreq', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
    { displayName: 'Tornado Annualized Frequency', dbColumn: 'ts_111_ap', legendName: 'transmission_exposure', apiLegend: true, type: 'line' },
  ];


  public getCejstBooleanProperties(): FilterRow[] {
    return this.cejstOptions.filter(row => row.legendName === 'cejst_boolean_attr');
  }

  public getCejstFundamentalsProperties(): FilterRow[] {
    return this.cejstOptions.filter(row => row.legendName === 'cejst_county_attr');
  }

  public getCejstPercentProperties(): FilterRow[] {
    return this.cejstOptions.filter(row => row.legendName === 'cejst_percent_attr');
  }

  public getCejstCountySummaryProperties(): FilterRow[] {
    return this.cejstOptions.filter(row => row.legendName === 'cejst_county_attr');
  }

  public getCejstPercentileProperties(): FilterRow[] {
    return this.cejstOptions.filter(row => row.legendName === 'cejst_percentile_attr');
  }

  public getEiaReliabilityProperties(): FilterRow[] {
    return this.eiaOptions.filter(row => row.legendName === 'eia_reliability');
  }

  public getEiaReliabilityFrequencyProperties(): FilterRow[] {
    return this.eiaOptions.filter(row => row.legendName === 'eia_reliability_frequency');
  }

  public getEiaMeterProperties(): FilterRow[] {
    return this.eiaOptions.filter(row => row.legendName === 'eia_meters');
  }

  public getEiaDistributionSystemsProperties(): FilterRow[] {
    return this.eiaOptions.filter(row => row.legendName === 'eia_distribution');
  }

  public getBurnProbabilityProperties(): FilterRow[] {
    return this.fireOptions.filter(row => row.legendName === 'fsim_burn_probability');
  }

  public getStateBurnIndexProperties(): FilterRow[] {
    return this.fireOptions.filter(row => row.legendName === 'state_burn_index');
  }

  public getIcfSubstationProperties(): FilterRow[] {
    return this.icfOptions.filter(row => row.legendName === 'substation_exposure');
  }
  public getIcfPowerplantProperties(): FilterRow[] {
    return this.icfOptions.filter(row => row.legendName === 'powerplant_exposure');
  }
  public getIcfTransmissionLinesProperties(): FilterRow[] {
    return this.icfOptions.filter(row => row.legendName === 'transmission_exposure');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public setYears(_years: number[]): void { /* deprecated stub */ }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public setTerritories(_territories: Territory[]): void { /* deprecated stub */ }

}
